type SectionHeadingProps = {
  title: string;
  align?: "left" | "center";
};

export function SectionHeading({ title, align = "left" }: SectionHeadingProps) {
  return (
    <div className={`section-heading section-heading--${align}`}>
      <h2>{title}</h2>
      <span className="section-heading-rule" aria-hidden="true" />
      <span className="datum" aria-hidden="true" />
    </div>
  );
}
